/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconNotifications/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconNotifications({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconNotifications",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconNotifications.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-Z1rHWoC': alignSelf,'--mt-2-Z1rHWoC': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1rHWoC': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1rHWoC': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1rHWoC': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1rHWoC': opacity,'--w-10-Z1rHWoC': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1rHWoC': typeof height === 'number' ? `${height}px` : height,'--a-7-Z1rHWoC': isAnimated ? animation : "none",'--sd-8-Z1rHWoC': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1rHWoC': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconNotifications.SvgPath"
  data-view-path={viewPath}
 d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"
 style={{'--f-12-Z1rHWoC': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}